import { EXODUS_ASSET_NAME_TO_TOKEN_NAME } from '@passkeys/ui/asset-icon';
import { useMemo } from 'react';

import type { Asset } from '@/types';

const KNOWN_TOKEN_NAMES = Object.keys(EXODUS_ASSET_NAME_TO_TOKEN_NAME);

export function isTokenVerified(token: Asset) {
  return (
    token.lifecycleStatus === 'c' ||
    token.isBuiltIn ||
    KNOWN_TOKEN_NAMES.includes(token.name)
  );
}

function useTokenVerified(token: Asset) {
  return useMemo(() => isTokenVerified(token), [token]);
}

export default useTokenVerified;
